// ProtectedImage.jsx
export default function ProtectedImage({
  src,
  alt = "",
  className = "", // Tailwind classes for size / layout
  imgClass = "", // extra classes for the <img> itself
  ...rest // any other <img> props
}) {
  return (
    /* 1️⃣  Wrapper:  relative  so overlay can be absolute
                      inline‑block so it auto‑sizes to the image
                      any Tailwind classes you pass in `className` */
    <div className={`relative inline-block ${className}`}>
      {/* 2️⃣  Real <img>
              - pointer‑events‑none so overlay catches events
              - select‑none & draggable={false} block drag/selection */}
      <img
        src={src}
        alt={alt}
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
        className={`pointer-events-none select-none ${imgClass}`}
        {...rest}
      />

      {/* 3️⃣  Transparent overlay  */}
      <div
        className="absolute inset-0 pointer-events-auto"
        onContextMenu={(e) => e.preventDefault()}
        draggable={false}
      />
    </div>
  );
}
